import CartSummaryTextil from "./CartSummaryTextil";

export default CartSummaryTextil;